import getEachDeep from './getEachDeep';
export default function getForEachDeep(_) {
  return getEachDeep(_);
}